var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.cruiseDetail.isRow)?_c('CruiseDetailRow'):_c('CruiseDetailHp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }